import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import {
  getBuyerLoginPath,
  getSellerLoginPath,
} from 'helpers/clientOnboarding';

/** Sends app users to their home tab, or the start screen when signed out. */
export function getAppHomePath(user) {
  if (!user) return '/app';
  return user.type === 'buyer' ? getBuyerLoginPath() : getSellerLoginPath();
}

// 302 so the WebView never caches a per-user redirect.
const AppHomeRedirect = () => {
  const user = useSelector((state) => state.auth.user);
  return (
    <Redirect
      to={{ pathname: getAppHomePath(user), state: { statusCode: 302 } }}
    />
  );
};

export default AppHomeRedirect;
